import Image from 'next/image'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

function Footer() {
  const { t } = useTranslation('fansiWin')

  return (
    <div className="flex flex-col items-center justify-center pb-12">
      <div className="flex items-center justify-center w-full gap-1 mb-8 lg:gap-4">
        <Image
          alt="mail"
          src="/assets/fansi-win/creators.png"
          height={64}
          width={64}
          layout="fixed"
          quality={75}
          loading="eager"
        />
        <div className="flex flex-col items-start">
          <p className="text-[#7A7A7A] font-bold md:text-lg lg:text-xl">
            {t('join_us_as_creator')}
          </p>
          <p className="text-[#7A7A7A] font-medium text-[8px] md:text-xs lg:text-sm">
            {t('join_us_as_creator_1')}
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center w-full gap-8 lg:gap-24">
        <div className="flex items-center justify-center gap-2 xl:hidden">
          <Image
            alt="mail"
            src="/assets/fansi-win/instagram.png"
            height={20}
            width={20}
            layout="fixed"
            quality={75}
            loading="eager"
          />
          <Image
            alt="mail"
            src="/assets/fansi-win/logo-small.png"
            height={60}
            width={90}
            layout="fixed"
            quality={75}
            loading="eager"
          />
        </div>
        <Link href="https://www.instagram.com/fansi.win/">
          <a target="_blank">
            <div className="items-center justify-center hidden gap-2 xl:flex">
              <Image
                alt="mail"
                src="/assets/fansi-win/instagram.png"
                height={32}
                width={32}
                layout="fixed"
                quality={75}
                loading="eager"
              />
              <Image
                alt="mail"
                src="/assets/fansi-win/logo-small.png"
                height={80}
                width={120}
                layout="fixed"
                quality={75}
                loading="eager"
              />
            </div>
          </a>
        </Link>
        <a href="mailto:start@fansi.pl">
          <div className="flex items-center justify-center gap-1 mt-4">
            <Image
              alt="mail"
              src="/assets/fansi-win/mail.png"
              height={18}
              width={24}
              layout="fixed"
              quality={75}
              loading="eager"
            />
            <p className="text-[#7A7A7A] text-sm font-medium">{t('mail')}</p>
          </div>
        </a>
      </div>
    </div>
  )
}

export default Footer
